import React,{useState} from 'react'
import { getBooking, getBookingById, getTermAndCondition, SearchMarqueeEventReport, SearchMarqueeEventReportForKitchen } from './MarqueeDetails.actions';
import { connect } from "react-redux";
import { Container, Form, Row, Col, Button, FormGroup } from "react-bootstrap";
import { isEmpty, find, sumBy, pick } from "lodash";
import Select from "react-select";
import { useEffect } from "react";
const BookingReport = (props) => {
  function uploadExpense(id) {
    reportType=="Kitchen"?props.SearchMarqueeEventReportForKitchen(id):
    props.SearchMarqueeEventReport(id,props.termAndCondition)
 }
  const [bookingId, setBookingId] = useState("");
  const [reportType, setReportType] = useState("");
  const getBookingList =!isEmpty(props.bookingList) &&
  props.bookingList.map((x) => {
    let data = { value: x.booking_id, label: `${x.booking_id} / ${x.booking_name} / ${x.booking_date}` };
    return data;
  });
  const reportTypeData=[{value:0,label:'Kitchen'},
  {value:1,label:'Customer'}]

  const reportTypeList =
  reportTypeData.map((x) => {
    let data = { value: x.value, label: x.label };
    return data;
  });
  const handleChangeReportType = (selectedOption) =>
  {
    setReportType(selectedOption.label)
      
  }
  const handleChangeBookingById = (selectedOption) =>
  {
     console.log(selectedOption, "sop")
      setBookingId(selectedOption.value);
     // setBookingName(selectedOption.label);
      props.getBookingById(selectedOption.value)
      
  }
  useEffect(() => {
    props.getBooking();
  }, []);
  return (
    <>
      <Container fluid>
          <Form>
          <Row>
                                    <Col lg="6" md="6" xs="6">
                                        <Form.Group className="mb-3" controlId="garana" >
                                            <Form.Label><b>Select booking:</b></Form.Label>
                                            <Select
                                            isDisabled={isEmpty(props.bookingList)}
                                                placeholder="Select booking..."
                                                onChange={handleChangeBookingById}
                                                options={getBookingList}
                                            />

                                        </Form.Group>
                                    </Col>
                                    <Col lg="6" md="6" xs="6">
                                        <Form.Group className="mb-3" controlId="garana" >
                                            <Form.Label><b>Select Report Type:</b></Form.Label>
                                            <Select
                                            // isDisabled={isEmpty(props.bookingList)}
                                                placeholder="Select Report Type..."
                                                onChange={handleChangeReportType}
                                                options={reportTypeList}
                                            />

                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div className="sendDiv">
                                  {bookingId==""||reportType==""?
                            <Button className="sendButton" disabled style={{backgroundColor:'black'}} onClick={() => { uploadExpense(props.bookingByIdList); }} >Generate Report</Button>:
                            <Button className="sendButton" onClick={() => { uploadExpense(props.bookingByIdList); }} >Generate Report</Button>}
                        </div>
                                </Form>
        </Container>
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBooking: () => dispatch(getBooking()),
    getBookingById:(id) => dispatch(getBookingById(id)),
    SearchMarqueeEventReport:(bookingByIdList,termAndCondition)=> dispatch(SearchMarqueeEventReport(bookingByIdList,termAndCondition)),
    SearchMarqueeEventReportForKitchen:(bookingByIdList)=> dispatch(SearchMarqueeEventReportForKitchen(bookingByIdList)),
    getTermAndCondition: () => dispatch(getTermAndCondition()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  bookingList: state.MarqueeReducer.bookingList,
  bookingByIdList: state.MarqueeReducer.bookingByIdList,
  termAndCondition: state.MarqueeReducer.termAndCondition,
  isFetchingTermAndCondition:state.MarqueeReducer.isFetchingTermAndCondition,
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingReport);

